<template>
<div style="display: inline;">
	<!-- table表格 -->
	<yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt"  getUrl="/web/basic/mouldEquipment/page" getKey="rows" :columns="columns">
	<template #conditions>

	</template>
	<!-- 左侧按钮插槽 -->
	<template #buttonsL>
		<el-button size="mini" @click="yt.showEditDialog('xinzeng',null,'w1')" type="primary">
			{{$t('xinzeng')}}
		</el-button>
	</template>
	<!-- 右侧按钮插槽 -->
	<template #buttonsR>
		<el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')"  @click="yt.showColumnsDialog()"></el-button>
	</template>
	<!-- 操作插槽 -->
	<template #caozuo="scope">
		<el-row :gutter="10">
			<el-col :span="0.1">
				<el-button type="text" @click="yt.showEditDialog('bianji', scope.row)">{{$t('bianji')}}
				</el-button>
			</el-col>
			<el-col :span="0.1">
				<el-button type="text" class="font-color-danger"
					@click="yt.remove(scope.row,'/web/equipment/series/delete')">{{$t('shanchu')}}</el-button>
			</el-col>
		</el-row>
	</template>
	</yi_curd_table>
</div>
</template>

<script type="text/javascript">
	export default {
		name: 'web_base_equipment_equipment_model',
		data() {
			return {
				columns: [{
					label: 'wuliaobianma',
					prop: 'typeId',
				}, {
					label: 'wuliaomingcheng',
					prop: 'name'
				}, {
					label: 'jibenfenlei',
					prop: 'name'
				}, {
					label: 'guize',
					prop: 'name'
				}, {
					label: 'dangqianliaohao',
					prop: 'name'
				}, {
					label: 'jiliangdanwei',
					prop: 'name'
				}, {
					label: 'baozhaungfenshi',
					prop: 'name'
				}, {
					label: 'maozhong',
					prop: 'name'
				}, {
					label: 'caozuo',
					type: 'slot',
					width: 250,
					fixed: 'right'
				}]
			};
		},
		created() {
			setTimeout(() => {
				
				this.yt.get(1)
				
			}, 300)


		},
		methods: {
		
		}
	};
</script>

<style>
</style>
